import { commonUtils } from './common_utils';

const dealerListSearch = {
    suggestForCookie: 'SUGGESTIONS_FROM_COOKIE',
    clearPreviousSearch: 'clear_previous_search',
    cookieName: 'search_dealer_free_text',
    showResultForSingleSuggest() {
        if (!$('#dealer_location').val() && 1 === $('#id_suggestion_text ul li').length) {
            $('#searchDealer').submit();
        }
    },
    showSearchDealerFreeText(value) {
        if ('Y' === value) {
            $('#searchDealer #search_dealer').prop('readonly', true);
            $('#searchDealer #search_dealer_free_text_cross').show();
        } else {
            $('#searchDealer #search_dealer').val('').prop('readonly', false);
        }
    },
    isAllowDistance(value) {
        let distanceDisable = true;
        if (value) {
            distanceDisable = false;
            $('#id_distance,#id_km, #dealerDistanceSelect').removeClass('opacity_class');
            $('#searchDealer #dealer_location').prop('readonly', true);
            $('#searchDealer #dealer_location_cross').show();
        } else {
            $('#dealerDistance').val('0');
            $('#id_distance,#id_km').addClass('opacity_class');
            $('#dealerDistanceSelect').addClass('opacity_class').val('0');
            $('#searchDealer #dealer_location').prop('readonly', false);
        }

        $('#dealerDistance,#dealerDistanceSelect').prop('disabled', distanceDisable);
    },
    setDealerSearchCookie(element, cookieName) {
        let newSearch = {};
        let currentSearch = $(element).val().trim();
        if (currentSearch) {
            newSearch[currentSearch] = { id: $(element).data('id'), label: currentSearch };
            let oldSearchList = dealerListSearch.getDealerSearchCookie(cookieName);
            if (!$.isEmptyObject(oldSearchList)) {
                $.each(oldSearchList, function (prevId, prevValue) {
                    if (Object.keys(newSearch).length < 5 && prevValue.label !== currentSearch) {
                        newSearch[prevValue.label] = prevValue;
                    }
                });
            }

            commonUtils.setCookie(cookieName, JSON.stringify(newSearch), 30 * 24 * 60);
        }
    },
    prepareDealerPreviousSearchOptions(cookieName) {
        let prevSearch = dealerListSearch.getDealerSearchCookie(cookieName);
        let prevSearchLabel = {};
        if (prevSearch) {
            let prevSearchClear = {};
            prevSearchLabel.previous_search = {
                id: 'previous_search',
                label: `${Translations.previous_search}:`,
            };
            prevSearchClear.clear_previous_search = {
                id: 'clear_previous_search',
                label: Translations.clear_previous_search,
            };
            $.extend(prevSearchLabel, prevSearch, prevSearchClear);
        }

        return prevSearchLabel;
    },
    getDealerSearchCookie(name) {
        return commonUtils.getCookie(name) ? $.parseJSON(commonUtils.getCookie(name)) : '';
    },
    searchByCompanyName() {
        $('#searchDealer #search_dealer')
            .autocomplete({
                appendTo: '#id_suggestion_text',
                source(request, response) {
                    let term = $.trim(request.term);
                    if (dealerListSearch.suggestForCookie === term) {
                        response(dealerListSearch.prepareDealerPreviousSearchOptions(dealerListSearch.cookieName));
                        return;
                    }

                    if (!commonUtils.isEmpty(term)) {
                        $.ajax({
                            url: Routing.generate('autosuggest_dealer_list', { type: 'search_dealer' }),
                            dataType: 'json',
                            type: 'GET',
                            data: { term },
                            success(data) {
                                response(data);
                            },
                        });
                    }
                },
                minLength: 2,
                select(_event, ui) {
                    if (dealerListSearch.clearPreviousSearch === ui.item.id) {
                        commonUtils.deleteCookie(dealerListSearch.cookieName);
                        return false;
                    }

                    let isDealerSearchText = 'N';
                    if (ui.item.id) {
                        $(this).data('id', ui.item.id);
                        isDealerSearchText = 'Y';
                    }

                    dealerListSearch.showSearchDealerFreeText(isDealerSearchText);
                    dealerListSearch.setDealerSearchCookie(
                        $('#searchDealer #search_dealer'),
                        dealerListSearch.cookieName
                    );

                    return undefined;
                },
            })
            .focus(function () {
                if ('' === this.value) {
                    $(this).data('ui-autocomplete').search('SUGGESTIONS_FROM_COOKIE');
                }
            })
            .data('ui-autocomplete')._renderItem = function (ul, item) {
            let { label } = item;
            if ('previous_search' === item.id) {
                return $('<li class="ui-state-disabled"></li>')
                    .data('item.autocomplete', item)
                    .html(label)
                    .appendTo(ul);
            }
            return $('<li></li>').data('item.autocomplete', item).html(label).appendTo(ul);
        };
    },
    searchByLocation() {
        $('#searchDealer #dealer_location').autocomplete({
            source(request, response) {
                let term = $.trim(request.term);
                if (!commonUtils.isEmpty(term)) {
                    $.ajax({
                        url: Routing.generate('autosuggest_dealer_list', { type: 'location' }),
                        dataType: 'json',
                        type: 'GET',
                        data: { term },
                        success(data) {
                            response(data);
                        },
                    });
                }
            },
            minLength: 2,
            select() {
                dealerListSearch.isAllowDistance(1);
            },
            classes: { 'ui-autocomplete': 'auto_suggest' },
        });
    },
    myFavouriteDealer(object) {
        if (!commonUtils.isUserLogin()) {
            almaTunnusLogin.init('dealer_list_tag_dealer_as_favorite');
            return false;
        }

        let idDealer = object.data('id');
        let operation = object.data('operation');
        let routeName = 'remove' === operation ? 'remove_favorite_dealer' : 'add_favorite_dealer';
        let params = `id=${idDealer}`;
        let listDealerPage = $('#dealerListing').length;
        let favoriteDealerPage = $('#favoriteDealerListing').length;
        let $clickedElement = object;
        $.post(Routing.generate(routeName), params, function (data) {
            if (data.error) {
                alert(data.error);
                return false;
            }

            if (data.message) {
                alert(data.message);
            }

            if ('add' === operation && favoriteDealerPage) {
                // Add from favorite dealer list page
                $(`#divFavId${idDealer}`).removeClass('remove-from-list');
                $clickedElement.removeClass('fav-dealer-list__removed');
                $clickedElement.data('operation', 'remove');
            } else if ('remove' === operation && favoriteDealerPage) {
                // Remove from favorite dealer list page
                $(`#divFavId${idDealer}`).addClass('remove-from-list');
                $clickedElement.addClass('fav-dealer-list__removed');
                $clickedElement.data('operation', 'add');
            } else if ('add' === operation && listDealerPage) {
                // Add from dealer list page
                $clickedElement.addClass('sub-dealer-list__favorites_added');
            } else if (operation === 'add') {
                // Add from VIF page
                $clickedElement.addClass('dealer-contact__all-link_star_saved');
                $clickedElement.removeClass('dealer-contact__all-link_star');
                $clickedElement.data('operation', 'remove');
                $clickedElement.text(Translations.ad_detail.contact.remove_favorite_dealer);
            } else if (operation === 'remove') {
                // Remove from VIF page
                $clickedElement.addClass('dealer-contact__all-link_star');
                $clickedElement.removeClass('dealer-contact__all-link_star_saved');
                $clickedElement.text(Translations.ad_detail.contact.add_favorite_dealer);
                $clickedElement.data('operation', 'add');
            }

            return undefined;
        });

        return undefined;
    },
};

$(function () {
    let $body = $('body');
    // Reset dealer/company search criteria
    $(document).on('click', '#searchDealer .resetDealerSearch', function () {
        $('#search_dealer').val('');
        $('#search_dealer_free_text_cross').hide();
        dealerListSearch.isAllowDistance('');

        $('#searchDealer').submit(); // Submit the form
    });

    // Reset location search criteria
    $(document).on('click', '#searchDealer .resetDealerLocation', function () {
        $('#dealer_location').val('');
        $('#dealer_location_cross').hide();
        dealerListSearch.isAllowDistance('');

        $('#searchDealer').submit();
    });

    // Auto suggest by town name
    dealerListSearch.searchByLocation();

    // Auto suggest by company name
    if ($('#searchDealer #search_dealer').length) {
        dealerListSearch.searchByCompanyName();
    }

    $body.on('click', '#id_suggestion_text ul li', function () {
        dealerListSearch.showResultForSingleSuggest();
    });

    $body.on('change', '#search_dealer, #dealer_location', function () {
        $(this).val($.trim($(this).val()));
    });

    // Add/remove dealer for favorite
    $(document).on('click', '.myFavoriteDealer', function () {
        const shouldContinue = commonUtils.handleZarazEvent($(this));
        if (!shouldContinue) {
            return;
        }
        dealerListSearch.myFavouriteDealer($(this));
    });

    $body.on('click', '.searchDealerForm', function () {
        if (commonUtils.isNettiauto()) {
            commonUtils.dataLayer.genericData({
                event: 'autoliikkeet',
                searchCompany: $('#search_dealer').val(),
                searchLocation: $('#dealer_location').val(),
            });
        }

        $('#searchDealer').submit();
    });
});
